'use strict';

var Sugar = require('sugar-core');

require('./build/buildDateUnitMethodsCall');

module.exports = Sugar.Date.addHours;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/date/addHours.js
// module id = 467
// module chunks = 0